module.exports = __webpack_public_path__ + "static/media/portrait5.4f3826c2.jpg";